import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccountModel } from '../../../../../../domain/models/account.model';
import { AccountContentService } from '../../../../../../domain/services/account-content/account-content.service';

/** Account-scoped NOTES tab. */
@Component({
  selector: 'app-account-notes-tab',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule],
  templateUrl: './account-notes-tab.component.html',
  styleUrl: './account-notes-tab.component.css'
})
export class AccountNotesTabComponent implements OnInit {
  @Input() account!: AccountModel;

  notes: any[] = [];
  newNoteContent = '';
  maxCharacters = 256;
  loadError: string | null = null;

  constructor(private contentService: AccountContentService) {}

  ngOnInit(): void {
    this.loadNotes();
  }

  loadNotes(): void {
    if (!this.account?.id) { return; }
    this.contentService.getNotes(this.account.id).subscribe({
      next: (notes) => { this.notes = notes; },
      error: (err) => { console.error('Error loading notes:', err); this.loadError = 'Unable to load notes.'; }
    });
  }

  getRemainingCharacters(): number {
    return this.maxCharacters - this.newNoteContent.length;
  }

  canPublish(): boolean {
    return this.newNoteContent.trim().length > 0 && this.newNoteContent.length <= this.maxCharacters;
  }

  publishNote(): void {
    if (!this.canPublish() || !this.account?.id) { return; }
    this.contentService.addNote(this.account.id, this.newNoteContent).subscribe({
      next: () => { this.newNoteContent = ''; this.loadNotes(); },
      error: (err) => console.error('Error publishing note:', err)
    });
  }
}
